export default "__VITE_ASSET__CzIyAPfA__"